import { render, staticRenderFns } from "./formatted_stage_count.vue?vue&type=template&id=178b6683"
import script from "./formatted_stage_count.vue?vue&type=script&lang=js"
export * from "./formatted_stage_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports